
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";
import {pickSeoTitle} from "~/helpers/seo-title";

export default {
  name: "index",

  head: function () {
    const title = this.seoTitle;
    const description = this.seoDescription;

    const fittedTitle = pickSeoTitle([
      title,
      `Грузоперевозки ${this.cityFrom} – ${this.cityTo}`,
    ], 70);

    return {
      __dangerouslyDisableSanitizers: ['script'],
      title: fittedTitle,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
      script: [
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Service',
            '@id': `https://centraltrans.ru${this.$route.path}#service`,
            'name': `Грузоперевозки ${this.cityFrom} – ${this.cityTo}`,
            'serviceType': 'Грузоперевозки',
            'url': `https://centraltrans.ru${this.$route.path}`,
            'areaServed': [
              {'@type': 'City', 'name': this.cityFrom},
              {'@type': 'City', 'name': this.cityTo}
            ],
            'provider': {
              '@type': 'Organization',
              'name': 'Central Trans',
              'url': 'https://centraltrans.ru/',
              'telephone': '+7 800 551 7490'
            },
            ...(this.minPriceFrom > 0 ? {
              'offers': {
                '@type': 'Offer',
                'priceCurrency': 'RUB',
                'price': String(this.minPriceFrom),
                'priceSpecification': {
                  '@type': 'UnitPriceSpecification',
                  'priceCurrency': 'RUB',
                  'price': String(this.minPriceFrom),
                  'minPrice': String(this.minPriceFrom),
                  'unitCode': 'C62'
                },
                'availability': 'https://schema.org/InStock',
                'url': `https://centraltrans.ru${this.$route.path}`
              }
            } : {})
          })
        },
        {
          type: 'application/ld+json',
          innerHTML: JSON.stringify(this.faqSchema)
        }
      ],
    }
  },
  asyncData: async function (ctx) {
    const { $api, route, error } = ctx;
    const cityFrom = route?.params?.cityfrom || "";
    const cityTo = route?.params?.cityto || "";
    const infoCity = await $api.agent.transport.get(`/route/from-to?slug_from=${cityFrom}&slug_to=${cityTo}`).then((res) => {
      return res.data
    }).catch(() => {
      return null
    });
    if (!infoCity || infoCity.length <= 0) {
      error({ statusCode: 404, message: 'Страница не найдена' });
      return
    }

    return {
      infoCity: infoCity
    }
  },

  computed: {
    breadcrumbs: function () {
      const cityFrom = (this.infoCity?.[0]?.city_from_case || this.infoCity?.[0]?.city_from || "");
      const cityTo = (this.infoCity?.[0]?.city_to_case || this.infoCity?.[0]?.city_to || "");

      return [
        { title: "Главная", path: "/" },
        { title: "Грузоперевозки по России", path: "/routes" },
        { title: `из ${cityFrom}`, path: `/routes/${this.$route.params?.cityfrom}` },
        { title: `в ${cityTo}`, path: this.$route.path },
      ]
    },

    h1: function () {
      return `Грузоперевозки ${this.cityFrom} – ${this.cityTo}`
    },
    seoTitle: function () {
      return `Грузоперевозки ${this.cityFrom} – ${this.cityTo}, цены на перевозку грузов`
    },
    seoDescription: function () {
      return `Грузоперевозки ${this.cityFrom} – ${this.cityTo} выделенным транспортом от Газели до фуры 20 тонн и низкорамными тралами. Транспортная компания Централ Транс`
    },

    cityFrom: function () {
      return this.infoCity?.[0]?.city_from || ""
    },
    cityTo: function () {
      return this.infoCity?.[0]?.city_to || ""
    },
    cityUser: function () {
      return this.$store.state?.appState?.config?.city?.data?.city_name
    },

    // FAQ для AEO/AI-поиска (только проверяемые данные страницы)
    faqSchema: function () {
      const row = this.infoCity?.[0] || {};
      const distance = Number.parseFloat(row.distance);
      const questions = [];

      if (this.minPriceFrom > 0) {
        questions.push({
          '@type': 'Question',
          'name': `Сколько стоит перевозка ${this.cityFrom} – ${this.cityTo}?`,
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': `Стоимость перевозки ${this.cityFrom} – ${this.cityTo} — от ${this.minPriceFrom.toLocaleString('ru-RU')} ₽ за машину. Точная цена зависит от веса, габаритов груза и типа транспорта; расчёт — по телефону 8 800 551 7490 или через форму на сайте.`
          }
        });
      }

      if (Number.isFinite(distance) && distance > 0) {
        questions.push({
          '@type': 'Question',
          'name': `Сколько километров по маршруту ${this.cityFrom} – ${this.cityTo}?`,
          'acceptedAnswer': {
            '@type': 'Answer',
            'text': `Расстояние по маршруту ${this.cityFrom} – ${this.cityTo} — ${distance} км.`
          }
        });
      }

      questions.push({
        '@type': 'Question',
        'name': `Каким транспортом перевозите грузы ${this.cityFrom} – ${this.cityTo}?`,
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Выделенный транспорт от Газели до фуры 20 тонн и низкорамные тралы: тент, рефрижератор, бортовой, самосвал, контейнеровоз, трал. Подбор машины — под тип и объём груза.'
        }
      });

      questions.push({
        '@type': 'Question',
        'name': 'Как заказать перевозку груза?',
        'acceptedAnswer': {
          '@type': 'Answer',
          'text': 'Оставьте заявку на сайте centraltrans.ru или позвоните по телефону 8 800 551 7490. Менеджер рассчитает стоимость и подберёт транспорт под ваш груз.'
        }
      });

      return {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': questions
      };
    },

    // Минимальная цена в рублях из тарифов маршрута — для Offer JSON-LD
    minPriceFrom: function () {
      const row = this.infoCity?.[0] || {};
      const prices = ['price_1_5', 'price_3', 'price_5', 'price_10', 'price_20']
        .map((key) => Number.parseFloat(row[key]))
        .filter((value) => Number.isFinite(value) && value > 0);

      return prices.length ? Math.min(...prices) : 0;
    },

    defaultSubdomain: function () {
      return this.$store.state?.appState?.vars?.['Дефолтный SLUG города'] || ""
    },

    ckEditorValue: function () {
      return {
        replaceKeys: {
          "route[From](parental)": this.infoCity?.[0]?.city_from_case || this.infoCity?.[0]?.city_from || "",
          "route[From]": this.infoCity?.[0]?.city_from || "",
          "route[To]": this.infoCity?.[0]?.city_to_case || this.infoCity?.[0]?.city_to || "",
        }
      }
    },
    freightRateTableTemplateRoutesValue: function () {
      return {
        cityInfo: this.infoCity?.[0] || {}
      }
    }
  },

  components: {
    Breadcrumbs
  },

  methods: {
    openFormSubmitApplication: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Оставить заявку",
          activeTab: "big",
          hideTabs: true,
          type: 'Оставить заявку'
        }
      });
    },
  }
}
